import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Check } from "lucide-react";
import api from "@/lib/api";
import { openWhatsApp } from "@/lib/whatsapp";
import { PrimaryLink } from "@/components/public/ui";
import useSeo from "@/lib/useSeo";

export default function ProductDetail() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/products/${slug}`).then(({ data }) => setP(data)).catch(() => setP(false)); }, [slug]);
  useSeo({ title: p?.seo_title || p?.name, description: p?.seo_description || p?.short_desc, image: p?.image });
  if (p === null) return <div className="max-w-7xl mx-auto px-6 py-32 text-center text-slate-400">Chargement…</div>;
  if (p === false) return <div className="max-w-7xl mx-auto px-6 py-32 text-center text-slate-500">Produit introuvable. <Link to="/produits" className="text-[#0F2A6B] underline">Retour</Link></div>;
  const specs = Array.isArray(p.caracteristiques) ? p.caracteristiques : (p.caracteristiques ? String(p.caracteristiques).split("\n") : []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <Link to="/produits" className="inline-flex items-center gap-2 text-slate-500 hover:text-[#0F2A6B] text-sm mb-6"><ArrowLeft className="w-4 h-4" /> Retour au catalogue</Link>
      <div className="grid lg:grid-cols-2 gap-10">
        <div className="rounded-2xl overflow-hidden border border-slate-200 bg-slate-50"><img src={p.image} alt={p.name} className="w-full h-[420px] object-cover" /></div>
        <div>
          <div className="text-xs font-mono text-slate-400 uppercase">{p.brand} · {p.category} · Réf. {p.reference}</div>
          <h1 className="mt-2 text-3xl sm:text-4xl font-bold text-slate-900 font-head">{p.name}</h1>
          <p className="mt-4 text-slate-600 leading-relaxed">{p.description}</p>
          {specs.length > 0 && <div className="mt-6 space-y-2">{specs.map((c, i) => (<div key={i} className="flex items-center gap-2 text-slate-700"><Check className="w-4 h-4 text-[#4CB944] shrink-0" />{c}</div>))}</div>}
          <div className="mt-8 p-6 rounded-2xl bg-white border border-slate-200 shadow-sm">
            <div className="flex items-center justify-between">
              <div><div className="text-sm text-slate-500">Prix</div><div className="text-2xl font-bold text-[#0F2A6B]">{p.price}</div></div>
              <span className={`text-sm px-3 py-1.5 rounded-full ${p.availability === "En stock" ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}>{p.availability}</span>
            </div>
            <PrimaryLink to="/devis" testid="product-devis-button" className="w-full mt-5">Demander un devis</PrimaryLink>
            <button onClick={() => openWhatsApp({ page: "produit", message: `Bonjour, je suis intéressé par ${p.name} (réf. ${p.reference}).` })} className="w-full mt-3 inline-flex items-center justify-center px-6 py-3 rounded-full border border-[#0F2A6B]/20 text-[#0F2A6B] font-semibold hover:bg-[#0F2A6B]/5">Discuter sur WhatsApp</button>
          </div>
        </div>
      </div>
    </div>
  );
}
